import script from "./fkp_old.vue?vue&type=script&setup=true&lang=js"
export * from "./fkp_old.vue?vue&type=script&setup=true&lang=js"

import "./fkp_old.vue?vue&type=style&index=0&id=5d8f8232&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8f8232"]])

export default __exports__